import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = {
    key: 0,
    class: "col col--half"
};
import FormBlock from "../../../../components/form/FormBlock.vue";
import Datepicker from "../../../../components/form/Datepicker.vue";
import { computed } from "vue";
import DeliveryTime from "./DeliveryTime.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryDateBlock',
    props: /*@__PURE__*/ _mergeModels({
        address: Object,
        calendar: Object,
        errors: Object,
        date: String,
        time: String,
        sameDay: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "date": {},
        "dateModifiers": {},
        "time": {},
        "timeModifiers": {},
        "dateFormatted": {},
        "dateFormattedModifiers": {},
    }),
    emits: ["update:modelValue", "update:date", "update:time", "update:dateFormatted"],
    setup(__props) {
        const props = __props;
        const dateValue = _useModel(__props, "modelValue");
        const date = _useModel(__props, 'date');
        const time = _useModel(__props, 'time');
        const dateFormatted = _useModel(__props, 'dateFormatted');
        // dates data
        const minDate = computed(() => new Date(props.calendar.minDate));
        const maxDate = computed(() => new Date(props.calendar.maxDate));
        const disabledDays = computed(() => props.calendar.noDelivery);
        const holidays = computed(() => props.calendar.holidays);
        const regions = computed(() => !(['Москва', 'Санкт-Петербург'].includes(props.address.cityName) || ['Москва'].includes(props.address.region)));
        const timesMode = computed(() => {
            if (!props.address) {
                return undefined;
            }
            if (props.sameDay) {
                return 'today';
            }
            if (!date.value) {
                return undefined;
            }
            if (regions.value) {
                return 'regions';
            }
            return holidays.value.includes(dateFormatted.value) ? 'holidays' : 'workdays';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(FormBlock, {
                disabled: !__props.address,
                alwaysVisible: "",
                title: __props.sameDay ? 'Укажите время доставки' : 'Укажите дату и время доставки'
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (!__props.sameDay)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(Datepicker, {
                                    label: "Предпочитаемая дата",
                                    minDate: minDate.value,
                                    maxDate: maxDate.value,
                                    holidays: holidays.value,
                                    disabledDays: disabledDays.value,
                                    error: __props.errors.delivery_date,
                                    required: "",
                                    modelValue: dateValue.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((dateValue).value = $event)),
                                    date: date.value,
                                    "onUpdate:date": _cache[1] || (_cache[1] = ($event) => ((date).value = $event)),
                                    dateFormatted: dateFormatted.value,
                                    "onUpdate:dateFormatted": _cache[2] || (_cache[2] = ($event) => ((dateFormatted).value = $event))
                                }, null, 8 /* PROPS */, ["minDate", "maxDate", "holidays", "disabledDays", "error", "modelValue", "date", "dateFormatted"])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col", { 'col--half': !__props.sameDay }])
                        }, [
                            _createVNode(DeliveryTime, {
                                name: "delivery_time",
                                mode: timesMode.value,
                                error: __props.errors.delivery_time,
                                modelValue: time.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((time).value = $event))
                            }, null, 8 /* PROPS */, ["mode", "error", "modelValue"])
                        ], 2 /* CLASS */)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled", "title"]));
        };
    }
});
